import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/complaint',
    name: 'complaint',
    component: () => import('../views/complaint.vue'),
    meta: {
      title: '投诉'
    }
  },
  {
    path: '/blindDateKF',
    name: 'blindDateKF',
    component: () => import('../views/blindDateKF.vue'),
    meta: {
      title: '客服二维码'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  // console.log(to, next)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
